<template>
  <ul
    class="mb-0"
    :role="[!isMobileMenu ? 'tablist' : '']"
    :class="[!isMobileMenu ? 'nav nav-tabs subnav' : 'p-1 border-1 border-primary border-left ms-4']"
    :style="{ 'list-style-type': isMobileMenu ? 'none !important' : '' }"
  >
    <li v-if="!isMobileMenu && network.logo_url" class="nav-item me-0">
      <avatar
        :src="network.logo_url"
        :username="network.short_name"
        class="img p-0 rounded-0 bg-dark"
        style="width: 45px; height: 45px"
      ></avatar>
    </li>
    <li
      :class="[!isMobileMenu ? 'pe-2' : ' px-2']"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item"
    >
      <router-link
        :to="'/networks/' + network.slug"
        :class="[!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white  nav-link ps-0 ']"
        role="tab"
        :active-class=isHomeActive()
      >
        {{ network.short_name }}
      </router-link>
    </li>
    <li
      :class="[!isMobileMenu ? '' : 'px-2']"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item px-2"
    >
      <router-link
        :to="'/networks/' + network.slug + '/media'"
        :class="[(!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white  nav-link ps-0', isMediaActive())]"
        active-class="active"
        role="tab"
      >
        {{ $t('nav.media') }}
      </router-link>
    </li>
    <li
      v-if="network.is_members_tab_visible && $auth.auth && !$auth.user.is_industry"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item px-2"
      >
      <router-link
        :to="'/networks/' + network.slug + '/members'"
        :class="[!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white  nav-link ps-0']"
        active-class="active"
        role="tab"
      >
        {{ $t('network.tabMembers') }}
      </router-link>
    </li>
    <li
      v-if="$auth.auth && network.is_messages_tab_visible"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item px-2"
      >
        <router-link
          :to="'/networks/' + network.slug + '/messages'"
          :class="[(!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white  nav-link ps-0', isAnnouncementsActive())]"
          active-class="active"
          role="tab"
        >
          {{ $t('announcements') }}
        </router-link>
    </li>
    <li
      v-if="$auth.auth && ($auth.hasRole('super-admin') || network.is_mine) && network.is_meetings_tab_visible"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item px-2"
      :class="[!isMobileMenu ? '' : 'px-2']"
    >
      <router-link
        :to="'/networks/' + network.slug + '/meetings'"
        :class="[!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white  nav-link ps-0', isNetworksActive()]"
        active-class="active"
        role="tab"
      >
        {{ $t('network.tabMeetings') }}
      </router-link>
    </li>
    <li
      v-if="network.can && network.can.view_usage_metrics && network.is_metrics_tab_visible"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item px-2"
    >
      <router-link
        :to="'/networks/' + network.slug + '/dashboard'"
        :class="[!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white nav-link ps-0']"
        active-class="active"
        role="tab"
      >
        {{ $t('network.usageMetrics') }}
      </router-link>
    </li>
    <li
      v-if="$auth.auth && $auth.hasRole('super-admin') && network.is_blog_tab_visible && network.slug == 'wb'"
      :style="{ border: isMobileMenu ? 'none !important' : '', 'font-size': isMobileMenu ? '14px !important' : '' }"
      class="nav-item px-2"
    >
      <router-link
        :to="'/networks/' + network.slug + '/blog'"
        :class="[!isMobileMenu ? 'nav-link text-white rounded-0' : 'bg-white nav-link ps-0']"
        active-class="active"
        role="tab"
      >
      {{ $t('blog') }}
      </router-link>
    </li>
  </ul>
</template>
<script>
import Avatar from 'vue-avatar';

export default {
  name: 'NetworksNav',
  components: {
    Avatar,
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
    isMobileMenu: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.isHomeActive();
    this.isMediaActive();
    this.isAnnouncementsActive();
  },
  methods:{
    isHomeActive() {
      if (this.$route.name == 'networks-edit' || this.$route.name == 'network-home') {
        return 'active';
      }
    },
    isMediaActive() {
      let mediaPath = (this.$route.path.startsWith(`/networks/${this.network.slug}/media`)
                    || this.$route.path === (`/networks/${this.network.slug}/create-media`));
      let collectionsPath = (this.$route.path.startsWith(`/networks/${this.network.slug}/collections`)
                    || this.$route.path === (`/networks/${this.network.slug}/create-collection`));
      if (mediaPath || collectionsPath) {
        return 'router-link-exact-active active nav-link text-white rounded-0';
      } else {
        return 'nav-link text-white rounded-0';
      }
    },
    isAnnouncementsActive() {
      if (this.$route.path.startsWith(`/networks/${this.network.slug}/messages`)
        || this.$route.path.startsWith(`/networks/${this.network.slug}/templates`)
        || this.$route.path.startsWith(`/networks/${this.network.slug}/template`)) {
        return 'router-link-exact-active active nav-link text-white rounded-0';
      } else {
        return 'nav-link text-white rounded-0';
      }
    },
    isNetworksActive() {
      if (this.$route.path.startsWith(`/networks/${this.network.slug}/meetings`)
        || this.$route.path.startsWith(`/networks/meeting/`)) {
        return 'router-link-exact-active active nav-link text-white rounded-0';
      } else {
        return 'nav-link text-white rounded-0';
      }
    },
  },
};
</script>
